<template>
    <div>
        <br>
        <b-container> 
            <div class="alert alert-danger text-center">
                <p>
                Actualmente ud se encuentra en el registro electoral.
                </p>
                <br>
                
        
                
                     
            </div> 
        </b-container>
    </div>
</template>
<script>
export default {
    name:'Redirect',
    data: function(){
        return { 
        }
    },
    methods:{
      
    },
    mounted(){ 
    }
}
</script>